<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Tax Reliefs"
      text="Update tax relief"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="localTaxRelief.name"
                v-validate="'required'" 
                label="Name"
                :error-messages="errors.collect('name')"
                data-vv-name="name"    
                data-vv-as="name" 
                outlined
              />
            </v-col>

            <v-col cols="12">
              <tiptap-vuetify
                v-model="localTaxRelief.description"
                class="full-width text-editor-toolbar-height pb-1"
                placeholder="Description"
                :extensions="extensions"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="localTaxRelief.amount"
                v-money="money"
                label="Amount"
                prefix="RM"
                outlined
              />
            </v-col>

            <v-col cols="12">
              <span>Compulsory Deduction? </span>
              <v-radio-group
                v-model="localTaxRelief.is_compulsory_deduction"
                class="mt-0"
                row
              >
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
                <v-radio
                  label="No"
                  :value="0"
                />
              </v-radio-group>
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="localTaxRelief.parent_id"
                label="Tax Relief Parent"
                :items="taxReliefParents"
                item-text="name"
                item-value="id"
                outlined
                clearable
              />
            </v-col>

            <v-col cols="12">
              <span>Relief or Rebate? </span>
              <v-radio-group
                v-model="localTaxRelief.type"
                class="mt-0"
                row
              >
                <v-radio
                  label="Relief"
                  value="relief"
                /> 
                <v-radio
                  label="Rebate"
                  value="rebate"
                />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-container>
      </form> 

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card>  
  </v-dialog>
</template>

<script>
  import { VMoney } from 'v-money'
  import { TiptapVuetify, Heading, Bold, Italic, Underline, BulletList, OrderedList, ListItem, Link, HardBreak } from 'tiptap-vuetify'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    directives: { money: VMoney },
    components: {
      TiptapVuetify,
    },
    props: {
      taxRelief: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localTaxRelief: null,
        loading: false,
        extensions: [
          Link,
          Underline,
          Italic,
          ListItem,
          BulletList,
          OrderedList,
          [Heading, {
            options: {
              levels: [1, 2, 3],
            },
          }],
          Bold,
          HardBreak,
        ],
        taxReliefParents: [],
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
        yearFilter: parseInt(this.$moment().format('YYYY')),
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true

        this.$api.taxReliefs().list({ year: this.yearFilter })
          .then(response => {
            this.taxReliefParents = _.orderBy(response.data, ['code'], ['asc'])
          })

        this.localTaxRelief = { ...this.taxRelief }

        if (this.localTaxRelief.amount) { this.localTaxRelief.amount = (Math.round((this.localTaxRelief.amount / 100) * 100) / 100).toFixed(2) }
            
        this.loading = false
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.taxReliefs().update(this.taxRelief.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
              .catch(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          name: this.localTaxRelief.name,
          description: this.localTaxRelief.description,
          is_compulsory_deduction: this.localTaxRelief.is_compulsory_deduction,
          type: this.localTaxRelief.type,
          parent_id: this.localTaxRelief.parent_id,
          amount: this.localTaxRelief.amount.toString().replaceAll(',', ''),
          year: this.localTaxRelief.year,
        }
      },
    },
  }
</script>

<style scoped>
.text-editor-toolbar-height>>> .v-toolbar__content{
  height: unset !important;
  min-height: 42px;
}
.text-editor-toolbar-height>>>.v-sheet.v-sheet--tile.theme--light.v-toolbar.v-toolbar--dense.v-toolbar--flat.grey.lighten-4{
  min-height:unset !important;
}
.full-width{
  width: 100%;
}
</style>

<style scoped>
.fix-date-picker-outline-overlap >>> label{
  background: white;
  padding-right:10px;
}
</style>
